import { useGetDoctypeDetailsQuery } from "../../../../store/api/itemapi";
import { useState } from 'react';
import Input from "../../../../Core/Fields/Floating/Input";

const EditItemModal = ({ show, onClose, itemData, onChange, full_Item_Detail, onSave, fulldata }) => {
  const { data: current_item, isLoading } = useGetDoctypeDetailsQuery({ "doctype": "Item", "name": itemData?.item_code });
  const [currentSerialInput, setCurrentSerialInput] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  if (!show || !itemData) return null;

  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...itemData, [name]: value });
  };

  const handleAddSerial = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      e.preventDefault();
      const serialValue = currentSerialInput.trim();

      if (!serialValue) {
        setError("Serial number cannot be empty");
        setSuccess("");
        return;
      }

      const currentSerials = itemData.serial_numbers || [];
      const maxAllowed = Number(full_Item_Detail.accepted_qty) || 0;

      if (currentSerials.includes(serialValue)) {
        setError("This serial number already exists");
        setSuccess("");
        return;
      }

      if (currentSerials.length >= maxAllowed) {
        setError(`You can only add ${maxAllowed} serial numbers for this Item.`);
        setSuccess("");
        return;
      }

      const updatedSerials = [...currentSerials, serialValue];
      onChange({ ...itemData, serial_numbers: updatedSerials });
      setCurrentSerialInput("");
      setError("");
      setSuccess("Serial number added successfully!");
      setTimeout(() => setSuccess(""), 2000);
    }
  };

  const handlePasteSerials = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');
    const serials = pastedText.split(/[\n,;\t]+/).filter(s => s.trim());

    if (serials.length === 0) return;

    const currentSerials = itemData.serial_numbers || [];
    const maxAllowed = Number(full_Item_Detail.qty) || 0;
    const availableSlots = maxAllowed - currentSerials.length;

    if (serials.length > availableSlots) {
      setError(`You can only add ${availableSlots} more serial numbers.`);
      setSuccess("");
      return;
    }

    const duplicates = serials.filter(s => currentSerials.includes(s));
    if (duplicates.length > 0) {
      setError(`These serial numbers already exist: ${duplicates.join(', ')}`);
      setSuccess("");
      return;
    }

    const newSerials = [...currentSerials, ...serials.slice(0, availableSlots)];
    onChange({ ...itemData, serial_numbers: newSerials });
    setError("");
    setSuccess(`${serials.slice(0, availableSlots).length} serial numbers added successfully!`);
    setTimeout(() => setSuccess(""), 2000);
  };

  const handleRemoveSerial = (index) => {
    const updatedSerials = [...(itemData.serial_numbers || [])];
    const removedSerial = updatedSerials.splice(index, 1);
    onChange({ ...itemData, serial_numbers: updatedSerials });
    setError("");
    setSuccess(`Serial number "${removedSerial}" removed`);
    setTimeout(() => setSuccess(""), 2000);
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header" style={{borderBottom : 'none'}}>
            <h5 className="modal-title">Edit Item</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="row mb-2">
              <div className="col-6">
                <Input
                  id="PO No."
                  label="PO No."
                  value={fulldata?.message?.items?.[0]?.purchase_order}
                  style={{ height: "30px" }}
                  readOnly
                />


              </div>
              <div className="col-6">
                <Input
                  id="Supplier"
                  label="Supplier"
                  value={fulldata?.message?.supplier}
                  style={{ height: "30px" }}
                  readOnly
                />

              </div>
            </div>
            <div className="row mb-2">
              <div className="col-6">
                <Input
                  id="Item Name"
                  label="Item Name"
                  value={full_Item_Detail.item_name}
                  style={{ height: "30px" }}
                  readOnly
                />

              </div>
              <div className="col-6">
                <Input
                  id="Item Code"
                  label="Item Code"
                  value={full_Item_Detail.item_code}
                  style={{ height: "30px" }}
                  readOnly
                />


              </div>
            </div>
            <div className="row mb-2">
              <div className="col-6">
                <Input
                  id="Rate"
                  label="Rate"
                  value={full_Item_Detail.rate}
                  style={{ height: "30px" }}
                  readOnly
                />

              </div>

              <div className="col-6">
                <Input
                  id="UOM"
                  label="UOM"
                  value={full_Item_Detail.uom}
                  style={{ height: "30px" }}
                  readOnly
                />

              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6">
                <Input
                  id="Total Qty"
                  label="Total Qty"
                  value={full_Item_Detail.qty}
                  style={{ height: "30px" }}
                  readOnly
                />


              </div>
              <div className="col-6">
                <Input
                  id="Expiry Date"
                  label="Expiry Date"
                  value={itemData.expiry_date || ""}
                  style={{ height: "30px" }}
                  readOnly
                />


              </div>

            </div>


            {current_item?.message?.has_serial_no == 1 && (
              <div className="row ">
                <div className="col-6" >



                  {current_item?.message?.has_serial_no == 1 && (


                    <div className="mb-2" style={{ marginBottom: '25px' }}>
                      <Input

                        id="Batch No."
                        label="Batch No."
                        name="batch_no"
                        value={itemData.batch_no || ""}
                        style={{ height: "30px" }}
                        onChange={handleInput}

                      />


                    </div>



                  )}


                  <div className="mb-2" style={{ marginTop: '10px', }}>

                    <div className="form-floating mb-2">
                      <input
                        type="text"
                        className="form-control p-0 px-2"
                        style={{ height: "30px", fontSize: "0.8rem" }}
                        value={currentSerialInput}
                        onChange={(e) => {
                          setCurrentSerialInput(e.target.value);
                          setError("");
                        }}
                        onKeyPress={handleAddSerial}
                        onPaste={handlePasteSerials}
                        placeholder="Scan serial number"
                      />
                      <label
                        htmlFor="staticInput"
                        style={{ height: "30px", color: "#212529a6", padding: '0.5rem 0.75rem', fontSize: "0.8rem" }}

                      >
                        Scan Serial Numbers
                      </label>
                    </div>


                    {error && (
                      <div className="alert alert-danger py-1 mb-2" style={{ fontSize: '0.8rem' }}>
                        {error}
                      </div>
                    )}

                    {success && (
                      <div className="alert alert-success py-1 mb-2" style={{ fontSize: '0.8rem' }}>
                        {success}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-6">
                  {/* Floating-style wrapper */}
                  <div className="mb-2 position-relative">
                    {/* Custom floating label */}
                    <label
                      htmlFor="serialNumberBox"
                      className="position-absolute"
                      style={{
                        top: '-10px',
                        left: '12px',
                        backgroundColor: '#ffff',
                        padding: '0 5px',
                        fontSize: '0.75rem',
                        color: '#6c757d',
                        zIndex: 1,
                      }}
                    >
                      Scanned Serial Numbers
                    </label>

                    {/* Serial numbers box */}
                    <div
                      id="serialNumberBox"
                      className="form-control"
                      style={{
                        height: '150px',
                        overflowY: 'auto',
                        fontSize: '0.8rem',
                        borderRadius: '10px',

                      }}
                    >
                      <div className="row g-2 " >
                        {itemData.serial_numbers?.length > 0 ? (
                          itemData.serial_numbers.map((serial, index) => (
                            <div className="col-6" key={index}>
                              <div
                                className="d-flex justify-content-between align-items-center border "
                                style={{
                                  borderRadius: '12px',
                                  padding: '4px 8px',
                                  fontSize: '0.75rem',
                                  lineHeight: '1.2',
                                  marginTop: '5px',
                                  background: '#EDEDED'
                                }}
                              >
                                <span
                                  className="text-truncate"
                                  style={{ maxWidth: '80%', overflow: 'hidden', whiteSpace: 'nowrap', color: 'gray' }}
                                >
                                  {index + 1}. {serial}
                                </span>

                                <button
                                  onClick={() => handleRemoveSerial(index)}
                                  type="button"
                                  className="btn btn-sm d-flex justify-content-center align-items-center p-0 ms-2"
                                  style={{
                                    width: '13px',
                                    height: '13px',
                                    background: 'white',
                                    border: 'none',
                                    color: 'black',
                                    fontSize: '10px',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                  }}
                                >
                                  ×
                                </button>

                              </div>
                            </div>

                          ))
                        ) : (
                          <div className="col-12 text-center text-muted">No serial numbers scanned yet</div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Total count */}
                  <div className="text-end" style={{ fontSize: '0.75rem' }}>
                    Total: {itemData.serial_numbers?.length || 0} serial numbers
                  </div>
                </div>

              </div>
            )}
          </div>
     
        </div>
      </div>
    </div>
  );
};

export default EditItemModal;